import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConsentTemplate,
  CONSENT_TEMPLATE_NORMALIZER,
  ConverterService,
  Occ,
  OccEndpointsService,
  OccUserConsentAdapter,
  OCC_USER_ID_CURRENT
} from '@spartacus/core'
import { CookieService } from 'ngx-cookie-service'
import { combineLatest, Observable, throwError } from 'rxjs'
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators'
import { EbUserIdService } from '../../../auth/services/eb-user-id.service'
import { EbBaseSiteService } from '../../../site-context/services/eb-base-site.service'
import { EbLanguageService } from '../../../site-context/services/eb-language.service'

@Injectable()
export class EbUserConsentAdapter extends OccUserConsentAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected userIdService: EbUserIdService,
    protected cookieService: CookieService,
    protected baseSiteService: EbBaseSiteService,
    protected languageService: EbLanguageService
  ) {
    super(http, occEndpoints, converter)
  }

  loadConsents(userId: string): Observable<ConsentTemplate[]> {
    return combineLatest([this.baseSiteService.getActive(), this.languageService.getActive()]).pipe(
      distinctUntilChanged((oldValue, newValue) => {
        return oldValue[0] === newValue[0] && oldValue[1] === newValue[1]
      }),
      switchMap(() => {
        // request is triggered before access_token cookie reaches frontend and user is set to current
        if (this.cookieService.get('asAgent')) {
          userId = OCC_USER_ID_CURRENT
        }
        const url = this.occEndpoints.buildUrl('consentTemplates', {
          urlParams: { userId }
        })
        const headers = new HttpHeaders({ 'Cache-Control': 'no-cache' })
        return this.http.get<Occ.ConsentTemplateList>(url, { headers }).pipe(
          catchError((error: any) => throwError(() => error)),
          map(consentList => consentList.consentTemplates),
          this.converter.pipeableMany(CONSENT_TEMPLATE_NORMALIZER)
        )
      })
    )
  }
}
